import { store } from '@/config/store';

/** Capture before awaiting: even A→B→A must invalidate an old response. */
export const captureCustomerSession = () => ({
  auth: store.state.authInfo,
});

export type CustomerSession = ReturnType<typeof captureCustomerSession>;

export const isCurrentCustomerSession = (session: CustomerSession): boolean =>
  session.auth === store.state.authInfo;
